export default "__VITE_ASSET__BrytODNO__"